import { TABLET_MIN, DESKTOP_MIN } from '@zola-helpers/client/dist/es/util/responsive';
import desktop1 from '../../../../public/static-preauth/images/AdvisorLp/CarouselDesktop/advisor_tiktok_desktop_01@2x.jpg';
import desktop2 from '../../../../public/static-preauth/images/AdvisorLp/CarouselDesktop/advisor_tiktok_desktop_02@2x.jpg';
import desktop3 from '../../../../public/static-preauth/images/AdvisorLp/CarouselDesktop/advisor_tiktok_desktop_03@2x.jpg';
import desktop4 from '../../../../public/static-preauth/images/AdvisorLp/CarouselDesktop/advisor_tiktok_desktop_04@2x.jpg';
import desktop5 from '../../../../public/static-preauth/images/AdvisorLp/CarouselDesktop/advisor_tiktok_desktop_06@2x.jpg';
import desktop6 from '../../../../public/static-preauth/images/AdvisorLp/CarouselDesktop/advisor_tiktok_desktop_07@2x.jpg';
import desktop7 from '../../../../public/static-preauth/images/AdvisorLp/CarouselDesktop/advisor_tiktok_desktop_08@2x.jpg';
import desktop8 from '../../../../public/static-preauth/images/AdvisorLp/CarouselDesktop/advisor_tiktok_desktop_09@2x.jpg';
import desktop9 from '../../../../public/static-preauth/images/AdvisorLp/CarouselDesktop/advisor_tiktok_desktop_10@2x.jpg';

import mobile1 from '../../../../public/static-preauth/images/AdvisorLp/CarouselMobile/carousel_tiktok_mobile_01@2x.jpg';
import mobile2 from '../../../../public/static-preauth/images/AdvisorLp/CarouselMobile/carousel_tiktok_mobile_02@2x.jpg';
import mobile3 from '../../../../public/static-preauth/images/AdvisorLp/CarouselMobile/carousel_tiktok_mobile_03@2x.jpg';
import mobile4 from '../../../../public/static-preauth/images/AdvisorLp/CarouselMobile/carousel_tiktok_mobile_04@2x.jpg';
import mobile5 from '../../../../public/static-preauth/images/AdvisorLp/CarouselMobile/carousel_tiktok_mobile_05@2x.jpg';
import mobile6 from '../../../../public/static-preauth/images/AdvisorLp/CarouselMobile/carousel_tiktok_mobile_06@2x.jpg';
import mobile7 from '../../../../public/static-preauth/images/AdvisorLp/CarouselMobile/carousel_tiktok_mobile_07@2x.jpg';
import mobile8 from '../../../../public/static-preauth/images/AdvisorLp/CarouselMobile/carousel_tiktok_mobile_08@2x.jpg';
import mobile9 from '../../../../public/static-preauth/images/AdvisorLp/CarouselMobile/carousel_tiktok_mobile_09@2x.jpg';

import tablet1 from '../../../../public/static-preauth/images/AdvisorLp/CarouselTablet/carousel_tiktok_tablet_01@2x.jpg';
import tablet2 from '../../../../public/static-preauth/images/AdvisorLp/CarouselTablet/carousel_tiktok_tablet_02@2x.jpg';
import tablet3 from '../../../../public/static-preauth/images/AdvisorLp/CarouselTablet/carousel_tiktok_tablet_03@2x.jpg';
import tablet4 from '../../../../public/static-preauth/images/AdvisorLp/CarouselTablet/carousel_tiktok_tablet_04@2x.jpg';
import tablet5 from '../../../../public/static-preauth/images/AdvisorLp/CarouselTablet/carousel_tiktok_tablet_05@2x.jpg';
import tablet6 from '../../../../public/static-preauth/images/AdvisorLp/CarouselTablet/carousel_tiktok_tablet_06@2x.jpg';
import tablet7 from '../../../../public/static-preauth/images/AdvisorLp/CarouselTablet/carousel_tiktok_tablet_07@2x.jpg';
import tablet8 from '../../../../public/static-preauth/images/AdvisorLp/CarouselTablet/carousel_tiktok_tablet_08@2x.jpg';
import tablet9 from '../../../../public/static-preauth/images/AdvisorLp/CarouselTablet/carousel_tiktok_tablet_09@2x.jpg';

type ImageData = {
  imageSrcs: { tablet: string; mobile: string; desktop: string };
  alt: string;
  imageType: 'png' | 'jpg' | 'webp';
};

function generateSourceElement(imageData: ImageData) {
  const { imageSrcs, alt, imageType } = imageData;
  return (
    <picture>
      <source
        media={`(min-width: ${DESKTOP_MIN}px)`}
        srcSet={`${imageSrcs.desktop}`}
        type={`image/${imageType}`}
      />
      <source
        media={`(min-width: ${TABLET_MIN}px)`}
        srcSet={`${imageSrcs.tablet}`}
        type={`image/${imageType}`}
      />
      <source media="(min-width: 1px)" srcSet={`${imageSrcs.mobile}`} type={`image/${imageType}`} />
      <img src={`${imageSrcs.mobile}.${imageType}`} alt={alt} />
    </picture>
  );
}

const images = [
  {
    img: generateSourceElement({
      imageSrcs: {
        tablet: tablet1,
        mobile: mobile1,
        desktop: desktop1,
      },
      alt: 'Bach Parties in Your 20s vs 30s',
      imageType: 'jpg',
    }),
    href: 'https://www.tiktok.com/@zola/video/7210913159404719402',
  },
  {
    img: generateSourceElement({
      imageSrcs: {
        tablet: tablet2,
        mobile: mobile2,
        desktop: desktop2,
      },
      alt: 'What your engagement ring says about you',
      imageType: 'jpg',
    }),
    href: 'https://www.tiktok.com/@zola/video/7208359137388973358',
  },
  {
    img: generateSourceElement({
      imageSrcs: {
        tablet: tablet3,
        mobile: mobile3,
        desktop: desktop3,
      },
      alt: 'How to change your name after your wedding',
      imageType: 'jpg',
    }),
    href: 'https://www.tiktok.com/@zola/video/7209318008488037675?is_from_webapp=1&sender_device=pc&web_id=7218624746436494894',
  },
  {
    img: generateSourceElement({
      imageSrcs: {
        tablet: tablet4,
        mobile: mobile4,
        desktop: desktop4,
      },
      alt: "5 Things Wedding Guest Don't Really Care About",
      imageType: 'jpg',
    }),
    href: 'https://www.tiktok.com/@zola/video/7206698887468404011',
  },
  {
    img: generateSourceElement({
      imageSrcs: {
        tablet: tablet5,
        mobile: mobile5,
        desktop: desktop5,
      },
      alt: "Wedding budget tips that don't work",
      imageType: 'jpg',
    }),
    href: 'https://www.tiktok.com/@zola/video/7218177978260393262',
  },
  {
    img: generateSourceElement({
      imageSrcs: {
        tablet: tablet6,
        mobile: mobile6,
        desktop: desktop6,
      },
      alt: 'Instagram Engagement Captions',
      imageType: 'jpg',
    }),
    href: 'https://www.tiktok.com/@zola/video/7178261566914219310',
  },
  {
    img: generateSourceElement({
      imageSrcs: {
        tablet: tablet7,
        mobile: mobile7,
        desktop: desktop7,
      },
      alt: 'How I feel about gifts my fiance wants for his "Man Cave"',
      imageType: 'jpg',
    }),
    href: 'https://www.tiktok.com/@zola/video/7171205528830496046?is_from_webapp=1&sender_device=pc&web_id=7218624746436494894',
  },
  {
    img: generateSourceElement({
      imageSrcs: {
        tablet: tablet8,
        mobile: mobile8,
        desktop: desktop8,
      },
      alt: '5 Things to remember before walking down the aisle',
      imageType: 'jpg',
    }),
    href: 'https://www.tiktok.com/@zola/video/7162656079212530986?is_from_webapp=1&sender_device=pc&web_id=7218624746436494894',
  },
  {
    img: generateSourceElement({
      imageSrcs: {
        tablet: tablet9,
        mobile: mobile9,
        desktop: desktop9,
      },
      alt: 'POV: You hired a Gen Z Wedding Planner',
      imageType: 'jpg',
    }),
    href: 'https://www.tiktok.com/@zola/video/7223375804108082478?is_from_webapp=1&sender_device=pc&web_id=7218624746436494894',
  },
];

export default images;
